const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "reference_contains",
      label: "Reference",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "clientFirstName_contains",
      label: "Client Firstname",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "clientSurname_contains",
      label: "Client Surname",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "clientReference_contains",
      label: "Client Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/AgentFilter"),
    main: true,
    props: {
      filterName: "gtAgentId_eq",
      label: "Agent",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    main: false,
    props: {
      filterName: "agentName_contains",
      label: "Agent Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/AgentTypeMultiFilter"),
    props: {
      filterName: "agent_type_eq",
      label: "Agent Type",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "internalReference_contains",
      label: "Internal Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brands",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "participants_contains",
      label: "Participant",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "startDate",
      label: "Itinerary start date between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "endDate",
      label: "Itinerary end date between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "creationDate",
      label: "Created date between",
      filterValue: null,
    },
  },

  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destinationId",
      label: "Destination",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "destination_name_contains",
      label: "Destination Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "createdBy_contains",
      label: "Created by",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "bookedBy_contains",
      label: "Booked by",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/ItineraryStatusFilter"),
    props: {
      filterName: "itineraryStatuses_eq",
      label: "Itinerary Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Departments",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/CurrencyFilter"),
    props: {
      filterName: "currency_eq",
      label: "Currency",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/NumberComparatorFilter"),
    main: true,
    props: {
      filterName: "balance",
      label: "Balance",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    main: true,
    props: {
      label: "Sales Invoice No",
      filterName: "salesInvoiceNo_contains",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/NumberComparatorFilter"),
    main: true,
    props: {
      filterName: "supplierCommissionBalance",
      label: "Supp. Comm. Balance",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/ItineraryTimeBasedFilter"),
    props: {
      filterName: "startDateTime",
      label: "Start Date",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "parent_reference_contains",
      label: "Parent Itinerary Ref",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/LeadSourceMultiFilter"),
    props: {
      filterName: "leadSources_eq",
      label: "Lead Source",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "has_service_groups_eq",
      label: "Has Service Groups",
      filterValue: { has_service_groups_eq: false },
    },
    defaultValue: { has_service_groups_eq: false },
    defaultLabel: false,
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    main: true,
    props: {
      label: "Agent Code",
      filterName: "agentCode_contains",
      filterValue: null,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/itineraries-filters.js